import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags, useNotifications } from '@fullstory/react-hooks';
import {
  AppDispatch,
  fullstorySelectors,
  SettingsRequestActions,
  settingsSelectors,
} from '@fullstory/redux';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const { getOrgId } = fullstorySelectors;
const { getSeatsInvites } = settingsSelectors;

// Fetches current org Seats, if the user has permission to view them.
export const useSeats = () => {
  const dispatch = useDispatch<AppDispatch>();
  const notifications = useNotifications();
  const orgId = useSelector(getOrgId);
  const seats = useSelector(getSeatsInvites);
  const flags = useFlags();
  const intl = useIntl();

  useEffect(() => {
    if (!flags.hasBit(Flag.PermViewTeam)) {
      // Will return an empty list
      return;
    }
    dispatch(SettingsRequestActions.getSeatsInvites({ orgId }, [], true, false)).catch(() => {
      notifications.error(
        intl.formatMessage({ defaultMessage: 'failed to load seats and invites', id: '/iAvq4' }),
      );
    });
  }, [dispatch, notifications, orgId, flags, intl]);

  return seats;
};
